import { Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Action, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitEmailContact } from 'assets-model';
import { openJustfoneDataTransferDialog } from '../../datatransfer/dialog/justfone-data-transfer-dialog.component';


@Component({
  selector: 'app-business-unit-email-contact-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class BusinessUnitEmailContactEditorComponent extends CrudEditComponent<BusinessUnitEmailContact, number> implements OnInit {

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();
    const self = this;
    this.actions = [];
    this.actions.push(<Action>{
      title: 'Justfone Debug',
      get enabled(): boolean { return !self.unsavedChanges() },
      color: "primary",
      get available(): boolean {
        return self.currentUserHasAnyAuthority("IS_SUPERUSER");
      },
      doAction() {
        openJustfoneDataTransferDialog(self.dialog, 'BusinessUnitEmailContact', self.item.businessUnitEmailContactId);
      }
    });
  }


}






